import { extractStreamInfos } from "./StreamInfo";
export default function createDisplayRecorderLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `display:${input.type}` });
    return {
        started(recording, streams) {
            return log({
                type: "started",
                details: { ...recording, streams: extractStreamInfos(streams) },
            });
        },
        stopped(details) {
            return log({
                type: "stopped",
                details,
            });
        },
    };
}
